export default __webpack_public_path__ + "static/media/sun.cc9c4821.svg";